import React from 'react';
//import {Link} from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';

function Footer(){
    return(
        <footer>
            <div className="footer">
                <div className="footer-container">
                     <section className="footer-top">
                         <Link smooth to="#main-header">Back to Top</Link>
                     </section>
                </div>
            </div>
        </footer>
    )
}

export default Footer;